import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=216f8670&scoped=true"
import script from "./message-template.vue?vue&type=script&lang=ts"
export * from "./message-template.vue?vue&type=script&lang=ts"
import style0 from "./message-template.vue?vue&type=style&index=0&id=216f8670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216f8670",
  null
  
)

export default component.exports